import { Skeleton } from '@chakra-ui/react';

const SkeletonComponent = (props) => (
  <Skeleton {...props} borderRadius={props?.borderRadius ?? '2px'} startColor="var(--color-neutral10)" endColor="var(--color-neutral20)" />
);

export default SkeletonComponent;
